import React, { useState, useEffect } from 'react';
import TrashIcon from '@rsuite/icons/Trash';
import ImageIcon from '@rsuite/icons/Image';
import EditIcon from '@rsuite/icons/Edit';
import CheckIcon from '@rsuite/icons/Check';

import CloseIcon from '@rsuite/icons/Close';

import {
    Input,
    InputGroup,
    IconButton,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Col,
    Form,
    FlexboxGrid,
    Container,
    SelectPicker,
    useToaster,
    Uploader,
    Message,
    Loader,
    Table,
    Button,
    InputNumber,
} from 'rsuite';
import FormControlLabel from 'rsuite/esm/FormControlLabel';

interface RowData {
    id: string; // or number, depending on your data
    attributes: {
        cmpnm: string,
        address: string,
        country: string,
        state: string,
        city: string,
        pin_no: 0,
        reg_type: string,
        org_type: string,
        faxno: 0,
        email_id: string,
        website: string,
        gstno: 0,
        cmpcd: string,
        madeby: "Shantanu",
        Bank_Detail: [
            {
                id: 3,
                bankName: string,
                branchName: string,
                ifsc_code: string,
                accountno: 0,
                bankaddress: string,
                swiftcode: string,
                cmpcd: null
            }
        ],
        Logo: {
            data: {
                attributes: {
                    url: string;
                    // Add other properties of CoverImage if needed
                };
            };
        };
        // Add other attributes if needed
    };
}

const country = ['USA', 'Russia', 'India', 'Pakistan', 'Australia', 'England', 'Germany',].map(
    item => ({ label: item, value: item })
);
const state = ['Uttar Pradesh', 'Madhya Pradesh', 'Delhi', 'Mumbai', 'Bihar', 'Jharkhand',].map(
    item => ({ label: item, value: item })
);
const city = ['Agra', 'Morababad', 'Noida', 'Firozabad', 'Etah', 'Shikohabad', 'Ghaziabad',].map(
    item => ({ label: item, value: item })
);
const regtype = ['Manufacturer', 'Importer', 'Dealer', 'Exporter', 'Reseller', 'Manufacturer & Exporter',].map(
    item => ({ label: item, value: item })
);
const orgtype = ['Individual/Proprietorship', 'Partnership', 'Private Ltd.', 'Public Ltd.', 'LLP',].map(
    item => ({ label: item, value: item })
);
const { Column, HeaderCell, Cell } = Table;

function previewFile(file, callback) {
    const reader = new FileReader();
    reader.onloadend = () => {
        callback(reader.result);
    };
    reader.readAsDataURL(file);
}

const CompanyMaster = () => {
    const ip = 'http://192.168.1.23:1337';
    const toaster = useToaster();
    const [uploading, setUploading] = React.useState(false);
    const [fileInfo, setFileInfo] = React.useState(null);

    // Api add data start
    const [data, setData] = useState({
        cmpnm: "",
        address: " ",
        country: "",
        state: "",
        city: "",
        pin_no: "0",
        reg_type: "",
        org_type: "",
        faxno: "0",
        email_id: "",
        website: "",
        gstno: "",
        cmpcd: "CMP1",
        madeby: "Shantanu",
        Bank_Detail: [
            {
                bankName: '',
                branchName: '',
                ifsc_code: '',
                accountno: '',
                bankaddress: '',
                swiftcode: ''
            }
        ],
        Logo: null,
    });

    const url = `${ip}/api/company-details`
    const submit = e => {
        if (data.cmpnm == '') {
            toaster2.push(message2, { placement: 'topCenter' })

        } else {
            e.preventDefault();
            const formData = new FormData();
            formData.append('data', JSON.stringify(data));
            formData.append('files.Logo', data.Logo);


            fetch(url, {
                method: 'POST',
                body: formData,
            })
                .then(response => fetchData())
                .then(data => console.log(data))
                .catch(error => console.error(error))
            setData({
                cmpnm: "",
                address: " ",
                country: "",
                state: "",
                city: "",
                pin_no: "0",
                reg_type: "",
                org_type: "0",
                faxno: "0",
                email_id: "0",
                website: "",
                gstno: "",
                cmpcd: "CMP1",
                madeby: "Shantanu",
                Bank_Detail: [
                    {
                        bankName: '',
                        branchName: '',
                        ifsc_code: '',
                        accountno: '',
                        bankaddress: '',
                        swiftcode: ''
                    }
                ],
                Logo: null,
            });

            toaster1.push(message1, { placement: 'topCenter' })
        }

    };

    const handleInputChange = (inputName, value, index) => {
        if (inputName === 'Bank_Detail') {
            setData(prevData => {
                const updatedBank_Detail = [...prevData.Bank_Detail];
                updatedBank_Detail[index] = {
                    ...updatedBank_Detail[index],
                    [value.name]: value.value
                };
                return {
                    ...prevData,
                    Bank_Detail: updatedBank_Detail
                };
            });
        } else {
            setData({ ...data, [inputName]: value });
        }
    };

    const handleImageUpload = fileList => {
        setData({
            ...data,
            Logo: fileList[0].blobFile
        });
    };
    // POST Data from API End

    // Fetch Data from API Start
    const [data1, setData1] = useState<RowData[]>([]);
    const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
    const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await fetch(`${ip}/api/company-details?populate=*`);
        const json = await response.json();
        setData1(json.data);
    };
    //  Fetch Data from API End
    const handleEditRow = (rowData) => {
        setEditedRowIds((prevRowIds) => [...prevRowIds, rowData.id]);
        setEditedData((prevData) => ({
            ...prevData,
            [rowData.id]: { ...rowData.attributes },
        }));
    };

    const handleSaveRow = async (rowId: string) => {
        try {
            const rowData = data1.find((row) => row.id === rowId);
            if (!rowData) {
                console.error('Row data not found.');
                return;
            }
            const updatedRowData: RowData = {
                ...rowData,
                attributes: { ...rowData.attributes, ...editedData[rowId] },
            };
            delete updatedRowData.attributes.Logo;
            const response = await fetch(`${ip}/api/company-details/${rowData.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ data: updatedRowData.attributes }),
            });
            if (response.ok) {
                // If the API call is successful, update the data
                fetchData();
                setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
            } else {
                // Handle error if needed
                console.error('Failed to save data');
            }
        } catch (error) {
            console.error('Error occurred while saving data', error);
        }
    };

    const handleInputChangeCommaster = (rowId, fieldName, value) => {
        setEditedData((prevData) => ({
            ...prevData,
            [rowId]: {
                ...prevData[rowId],
                [fieldName]: value,
            },
        }));
    };
    // Delete Data from API Start
    // const handleDeleteRow = async (rowId) => {
    //     try {
    //         const response = await fetch(`${ip}/api/company-details/${rowId}`, {
    //             method: 'DELETE',
    //         });
    //         if (response.ok) {
    //             // Row deletion was successful, update your local data or refresh the table
    //             const updatedData1 = data1.filter((row) => row.id !== rowId);
    //             setData1(updatedData1);
    //             console.log('Row deleted successfully.');
    //         } else {
    //             console.log('Failed to delete row.');
    //         }
    //     } catch (error) {
    //         console.error('Error deleting row:', error);
    //     }
    // };
    // Fetch Data from API End

    // for Massage after sumbit form

    const toaster1 = useToaster();

    const message1 = (
        <Message showIcon type='success' closable>
            Company Details Saved Successfully.
        </Message>
    );

    const toaster2 = useToaster();

    const message2 = (
        <Message showIcon type='error'>
            Please fill the company details.
        </Message>
    );
    const [rows, setRows] = useState([
        { id: 1, name: '', age: '', email: '' },

    ]);

    const handleAddRow = () => {
        setRows([...rows, { id: rows.length + 1, name: '', age: '', email: '' }]);
    };

    const handleDeleteRow1 = (id) => {
        setRows(rows.filter((row) => row.id !== id));
    };

    //   const handleChange = (id, key, value) => {
    //     setRows((prevRows) =>
    //       prevRows.map((row) => (row.id === id ? { ...row, [key]: value } : row))
    //     );
    //   };

    return (
        <>
            <Container className='main table-toolbar'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack.Item alignSelf="flex-start">
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Company</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                                <Breadcrumb.Item active>Company</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                    </Stack.Item>
                </Stack>
                <Divider className='divide' />
                <Message type="info" ><b>Company Details </b></Message>
                <Panel>
                    <FlexboxGrid justify="space-between">
                        <FlexboxGrid.Item as={Col} colspan={24} md={16}>
                            <FlexboxGrid justify="space-between">
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                                    <Form.ControlLabel><Stack><p>Company Name</p><p style={{color:'red'}}>*</p></Stack></Form.ControlLabel>
                                    <Input
                                        id="cmpnm"
                                        name="cmpnm"
                                        value={data && data.cmpnm ? data.cmpnm : ''} onChange={value => handleInputChange('cmpnm', value, 0)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                    <Form.ControlLabel>Address</Form.ControlLabel>
                                    <Input
                                        id="address"
                                        name="address"
                                        value={data && data.address ? data.address : ''} onChange={value => handleInputChange('address', value, 0)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Country</Form.ControlLabel>
                                    <SelectPicker id="country"
                                        name="country"
                                        value={data && data.country ? data.country : ''} onChange={value => handleInputChange('country', value, 0)}
                                        data={country} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                                    <Form.ControlLabel>State</Form.ControlLabel>
                                    <SelectPicker
                                        id="state"
                                        name="state"
                                        value={data && data.state ? data.state : ''} onChange={value => handleInputChange('state', value, 0)}
                                        data={state} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>City</Form.ControlLabel>
                                    <SelectPicker
                                        id="city"
                                        name="city"
                                        value={data && data.city ? data.city : ''} onChange={value => handleInputChange('city', value, 0)}
                                        data={city} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>PIN No.</Form.ControlLabel>
                                    <Input
                                        id="pin_no"
                                        name="pin_no"
                                        value={data && data.pin_no ? data.pin_no : ''} onChange={value => handleInputChange('pin_no', value, 0)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }} >
                                    <Form.ControlLabel>Registration Type</Form.ControlLabel>
                                    <SelectPicker
                                        id="reg_type"
                                        name="reg_type"
                                        value={data && data.reg_type ? data.reg_type : ''} onChange={value => handleInputChange('reg_type', value, 0)}
                                        data={regtype} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Organisation Type</Form.ControlLabel>
                                    <SelectPicker
                                        id="org_type"
                                        name="org_type"
                                        value={data && data.org_type ? data.org_type : ''} onChange={value => handleInputChange('org_type', value, 0)}
                                        data={orgtype} block />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Contact No.</Form.ControlLabel>
                                    <InputNumber

                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }} >
                                    <Form.ControlLabel>Email</Form.ControlLabel>
                                    <Input
                                        id="email_id"
                                        name="email_id"
                                        value={data && data.email_id ? data.email_id : ''} onChange={value => handleInputChange('email_id', value, 0)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>Website</Form.ControlLabel>
                                    <Input
                                        id="website"
                                        name="website"
                                        value={data && data.website ? data.website : ''} onChange={value => handleInputChange('website', value, 0)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                    <Form.ControlLabel>GST No.</Form.ControlLabel>
                                    <Input
                                        id="gstno"
                                        name="gstno"
                                        value={data && data.gstno ? data.gstno : ''} onChange={value => handleInputChange('gstno', value, 0)}
                                    />
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                            <Stack justifyContent='center'>
                                <Uploader
                                    onChange={handleImageUpload}
                                    fileListVisible={false}
                                    listType="picture"
                                    action={""}
                                    onUpload={file => {
                                        setUploading(true);
                                        previewFile(file.blobFile, value => {
                                            setFileInfo(value);
                                        });
                                    }}
                                    onSuccess={(response, file) => {
                                        setUploading(false);
                                        toaster.push(<Message type="success">Uploaded successfully</Message>);
                                        console.log(response);
                                    }}
                                    onError={() => {
                                        setFileInfo(null);
                                        setUploading(false);
                                        toaster.push(<Message type="success">Uploaded successfully</Message>);
                                    }}
                                >
                                    <button style={{ width: 232, height: 196 }}>
                                        {uploading && <Loader backdrop center />}
                                        {fileInfo ? (
                                            <img src={fileInfo} width="100%" height="100%" />
                                        ) : (
                                            <ImageIcon style={{ fontSize: 80 }} />
                                        )}
                                    </button>
                                </Uploader>
                            </Stack>
                            <Stack justifyContent='center'>
                                <IconButton size="md" icon={<TrashIcon />} onClick={() => setFileInfo(null)} active />
                            </Stack>


                        </FlexboxGrid.Item>

                    </FlexboxGrid>
                    {rows.map((row) => (
                        <div key={row.id} style={{ marginBottom: '10px' }}>
                            <FlexboxGrid justify="space-between">

                                <FlexboxGrid.Item as={Col} colspan={24} md={16}>
                                    <FlexboxGrid justify="space-between">
                                        <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                            <FormControlLabel>Name</FormControlLabel>
                                            <Input
                                                placeholder="Name"
                                            />
                                        </FlexboxGrid.Item>
                                        <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                            <FormControlLabel>Mobile No.</FormControlLabel>
                                            <Input
                                                placeholder="Mobile No."
                                            />
                                        </FlexboxGrid.Item>
                                        <FlexboxGrid.Item as={Col} colspan={24} md={8} >
                                            <FormControlLabel>Email</FormControlLabel>
                                            <Input
                                                placeholder="Email"
                                            />
                                        </FlexboxGrid.Item>
                                    </FlexboxGrid>
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                    {rows.length > 1 && (
                                        <IconButton active style={{ marginTop: '20px' }} onClick={() => handleDeleteRow1(row.id)} icon={<TrashIcon />} />
                                    )}
                                </FlexboxGrid.Item>

                            </FlexboxGrid>
                        </div>
                    ))}
                    <Button active onClick={handleAddRow}>
                        Add Row
                    </Button>
                </Panel>
                <Message type="info" ><b>Bank Details</b></Message>
                <Panel>

                    {data.Bank_Detail.map((material, index) => (
                        <div key={index}>
                            <FlexboxGrid justify='start'>
                                <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '10px' }}>
                                    <Form.ControlLabel>Bank Name</Form.ControlLabel>
                                    <Input
                                        name="bankName"
                                        value={material.bankName}
                                        onChange={value => handleInputChange('Bank_Detail', { name: 'bankName', value: value }, index)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                                    <Form.ControlLabel>Branch Name</Form.ControlLabel>
                                    <Input
                                        name="branchName"
                                        value={material.branchName}
                                        onChange={value => handleInputChange('Bank_Detail', { name: 'branchName', value: value }, index)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                                    <Form.ControlLabel>IFSC Code</Form.ControlLabel>
                                    <Input
                                        name="ifsc_code"
                                        value={material.ifsc_code}
                                        onChange={value => handleInputChange('Bank_Detail', { name: 'ifsc_code', value: value }, index)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                                    <Form.ControlLabel>Account No.</Form.ControlLabel>
                                    <Input
                                        name="accountno"
                                        value={material.accountno}
                                        onChange={value => handleInputChange('Bank_Detail', { name: 'accountno', value: value }, index)}
                                    />
                                </FlexboxGrid.Item>

                                <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                                    <Form.ControlLabel>Address</Form.ControlLabel>
                                    <Input
                                        name="bankaddress"
                                        value={material.bankaddress}
                                        onChange={value => handleInputChange('Bank_Detail', { name: 'bankaddress', value: value }, index)}
                                    />
                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={6} >
                                    <Form.ControlLabel>Swift Code</Form.ControlLabel>
                                    <Input
                                        name="swiftcode"
                                        value={material.swiftcode}
                                        onChange={value => handleInputChange('Bank_Detail', { name: 'swiftcode', value: value }, index)}
                                    />
                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        </div>
                    ))}

                    <Stack justifyContent='flex-end'>
                        <Button appearance='primary' color='cyan' onClick={submit}>Save</Button>
                    </Stack>


                    <Divider><b>Company Details</b></Divider>

                    <Table
                        rowHeight={60}
                        data={data1}
                        height={500}
                        rowKey="id"
                        bordered
                    >
                        <Table.Column width={60} align="center" fixed>
                            <HeaderCell><b>Sr. No.</b></HeaderCell>
                            <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Company Name</b></Table.HeaderCell>
                            <Table.Cell>
                                {(rowData) => (
                                    editedRowIds.includes(rowData.id) ? (
                                        <Input
                                            value={editedData[rowData.id]?.cmpnm || rowData.attributes.cmpnm}
                                            onChange={(value) => handleInputChangeCommaster(rowData.id, 'cmpnm', value)}
                                        />
                                    ) : (
                                        rowData.attributes.cmpnm
                                    )
                                )}
                            </Table.Cell>
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>City</b></Table.HeaderCell>
                            <Table.Cell>
                                {(rowData) => (
                                    editedRowIds.includes(rowData.id) ? (
                                        <Input
                                            value={editedData[rowData.id]?.city || rowData.attributes.city}
                                            onChange={(value) => handleInputChangeCommaster(rowData.id, 'city', value)}
                                        />
                                    ) : (
                                        rowData.attributes.city
                                    )
                                )}
                            </Table.Cell>
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>GST.No</b></Table.HeaderCell>
                            <Table.Cell>
                                {(rowData) => (
                                    editedRowIds.includes(rowData.id) ? (
                                        <Input
                                            value={editedData[rowData.id]?.gstno || rowData.attributes.gstno}
                                            onChange={(value) => handleInputChangeCommaster(rowData.id, 'gstno', value)}
                                        />
                                    ) : (
                                        rowData.attributes.gstno
                                    )
                                )}
                            </Table.Cell>
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>FAX No.</b></Table.HeaderCell>
                            <Table.Cell>
                                {(rowData) => (
                                    editedRowIds.includes(rowData.id) ? (
                                        <Input
                                            value={editedData[rowData.id]?.faxno || rowData.attributes.faxno}
                                            onChange={(value) => handleInputChangeCommaster(rowData.id, 'faxno', value)}
                                        />
                                    ) : (
                                        rowData.attributes.faxno
                                    )
                                )}
                            </Table.Cell>
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Email</b></Table.HeaderCell>
                            <Table.Cell>
                                {(rowData) => (
                                    editedRowIds.includes(rowData.id) ? (
                                        <Input
                                            value={editedData[rowData.id]?.email_id || rowData.attributes.email_id}
                                            onChange={(value) => handleInputChangeCommaster(rowData.id, 'email_id', value)}
                                        />
                                    ) : (
                                        rowData.attributes.email_id
                                    )
                                )}
                            </Table.Cell>
                        </Table.Column>

                        <Table.Column width={150} fixed="right">
                            <Table.HeaderCell><b>Action</b></Table.HeaderCell>

                            <Table.Cell style={{ padding: '6px', gap: "10px" }}>
                                {(rowData) => (
                                    editedRowIds.includes(rowData.id) ? (
                                        <div>
                                            <IconButton
                                                size="sm"
                                                icon={<CheckIcon />}
                                                active
                                                onClick={() => handleSaveRow(rowData.id)}
                                                style={{ marginRight: '10px' }}
                                            />
                                            <IconButton
                                                size="sm"
                                                icon={<CloseIcon />}
                                                active
                                                onClick={() => setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <IconButton
                                                size="sm"
                                                icon={<EditIcon />}
                                                active
                                                onClick={() => handleEditRow(rowData)}
                                            />
                                            {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                                        </div>
                                    )
                                )}
                            </Table.Cell>
                        </Table.Column>
                    </Table>
                </Panel>


                <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
                    <div className="container">
                        <p>© All Right Reserved. Product by </p>
                    </div>
                    <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
                </Stack>
            </Container>
        </>
    );
};

export default CompanyMaster;